import axios, { InternalAxiosRequestConfig } from "axios";
import tokenUpdate from "./tokenUpdate";

// Interface para estrutura do token salvo no localStorage
interface TokenData {
  token: string;
  refreshToken: {
    usuarioClienteId: string;
  };
}

// Interface para estrutura do acesso salvo no localStorage
interface AcessoData {
  acessoClientesId: string;
}

const token = (): string => {
  const result = localStorage.getItem("1");
  if (result) {
    const parsed: TokenData = JSON.parse(result);
    return parsed.token;
  }
  return "";
};

const usuarioId = (): string => {
  const result = localStorage.getItem("1");
  if (result) {
    const parsed: TokenData = JSON.parse(result);
    return parsed.refreshToken.usuarioClienteId;
  }
  return "";
};

const acessoClientId = (): string => {
  const result = localStorage.getItem("acesso");
  if (result) {
    const parsed: AcessoData[] = JSON.parse(result);
    return parsed[0]?.acessoClientesId || "";
  }
  return "";
};
const logsLoginClienteId = (): string => {
  const result = localStorage.getItem("logs");
  if (result) {
    const parsed = JSON.parse(result);
    return parsed?.id || "";
  }
  return "";
};

const api = axios.create();

api.interceptors.request.use(
  async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const baseUrl = window?.config?.REACT_APP_BASE_URL || "";

    if (token()) {
      try {
        const tokenAtual = token();
        const user = usuarioId();
        const acesso = acessoClientId();
        const logsId = logsLoginClienteId();

        config.baseURL = baseUrl;
        config.headers = config.headers || {};
        config.headers.Authorization = tokenAtual ? `Bearer ${tokenAtual}` : "";
        config.headers["x-user-id"] = user || "";
        // Adiciona o acessoClientesId no corpo da requisição
        if (!config.data) config.data = {};
        config.data.logsLoginClienteId = logsId;

        // Atualiza o token antes de continuar com a requisição
        //     await tokenUpdate(tokenAtual);

        return config;
      } catch (error) {
        console.error(error);
      }
    } else {
      if (window?.config) {
        // localStorage.clear();
        // window.location.replace("/login");
      }
    }

    return config;
  }
);

export default api;
